import { useMutation } from '@platform/api-client';
import type { TypedClient } from '@platform/openapi';
import type { AdjustmentLine } from './stock-adjustment.ts';
import { usePageContext } from '../usePageContext.ts';

const STOCK_RESOURCES = ['stock-levels', 'low-stock', 'movements', 'products', 'dashboard'] as const;

export const useRecordStock = (api: TypedClient, onRecorded: (count: number) => void) => {
  const { invalidate } = usePageContext();
  return useMutation({
    mutationFn: (lines: readonly AdjustmentLine[]) =>
      api.post('/admin/stock-movements/batch', { body: { lines: [...lines] } }),
    onSuccess: (result) => {
      void invalidate(...STOCK_RESOURCES);
      onRecorded(result.items.length);
    },
  });
};
